import type { ButtonHTMLAttributes } from 'react';
import s from './ui.module.css';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';

export function Button({
  variant = 'secondary',
  size,
  className,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; size?: 'small' | 'large' }) {
  return (
    <button
      type="button"
      className={[s.btn, variant !== 'secondary' ? s[variant] : '', size ? s[size] : '', className ?? ''].join(' ')}
      {...rest}
    />
  );
}

export function Spinner() {
  return <span className={s.spinner} aria-hidden="true" />;
}

export function Segmented<T extends string>({
  value,
  options,
  onChange,
  disabled,
  label,
}: {
  value: T;
  options: { value: T; label: string }[];
  onChange: (v: T) => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <div className={s.segmented} role="group" aria-label={label}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={s.segment}
          aria-pressed={o.value === value}
          disabled={disabled}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
